import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {PriceBookExtensionContainerModel} from '../../../../../../models/aggregates/erp/price-book';
import {Core2Config} from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class PriceBookExtService extends BaseApiTemplateService<PriceBookExtensionContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'fi-price-book-ext';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'fi-price-book-ext';
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + 'fi-price-book-ext';
    this.httpClient = http;
  }

}


